/**
* Adds leading zero to hours or minutes when needed.
* @param {number} n Number of hours or minutes.
* @returns {string} The hours or minutes with leading zero when needed.
*/
export function addZero(n) {
    return (n < 10) ? ('0' + n) : n.toString();
}
